import { Routes } from '@angular/router';
import { canActivateAuthRole } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'patients', pathMatch: 'full' },
  {
    path: 'patients',
    loadChildren: () =>
      import('./modules/patients/patients.routes').then(
        (m) => m.PATIENTS_ROUTES
      ),
      canActivate: [canActivateAuthRole],
      data: { role: 'PACIENTE' }
  },
  {
    path: 'administrator',
    loadChildren: () =>
      import('./modules/administrator/administrator.routes').then(
        (m) => m.ADMINISTRATOR_ROUTES
      ),
      canActivate: [canActivateAuthRole],
      data: { role: 'DOCTOR' }
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.routes').then(
        (m) => m.AUTH_ROUTES
      ),
    canActivate: [canActivateAuthRole]
  },
  {
    path: 'selene-link',
    loadComponent: () => 
      import('./modules/selene-link/selene-link.component').then(
        (m) => m.SeleneLinkComponent
      )
  },
  { path: '**', redirectTo: 'patients' },
];
